var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnBoost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 6.3001H5.49905V4.24435C5.49905 3.3377 6.26168 2.6001 7.19905 2.6001C8.13643 2.6001 8.89905 3.3377 8.89905 4.24435V5.2001H9.89905V4.24435C9.89905 2.7863 8.68783 1.6001 7.19905 1.6001C5.71028 1.6001 4.49905 2.7863 4.49905 4.24435V6.3001H3.59998C2.77288 6.3001 2.09998 6.973 2.09998 7.8001V12.9001C2.09998 13.7272 2.77288 14.4001 3.59998 14.4001H10.8C11.6271 14.4001 12.3 13.7272 12.3 12.9001V7.8001C12.3 6.973 11.6271 6.3001 10.8 6.3001ZM11.3 12.9001C11.3 13.1758 11.0757 13.4001 10.8 13.4001H3.59998C3.32428 13.4001 3.09998 13.1758 3.09998 12.9001V7.8001C3.09998 7.5244 3.32428 7.3001 3.59998 7.3001H10.8C11.0757 7.3001 11.3 7.5244 11.3 7.8001V12.9001Z",
    fill: "#00D1D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20002 8.75C6.68915 8.75 6.27502 9.16413 6.27502 9.675C6.27502 10.0012 6.44402 10.2877 6.6991 10.4524V11.55C6.6991 11.8261 6.92295 12.05 7.1991 12.05C7.47522 12.05 7.6991 11.8261 7.6991 11.55V10.4536C7.9552 10.2891 8.12502 10.002 8.12502 9.675C8.12502 9.16413 7.7109 8.75 7.20002 8.75Z",
    fill: "#00D1D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnBoost);
export default __webpack_public_path__ + "static/media/un-boost.853cf58b28822d12cbbf911d2cd855b7.svg";
export { ForwardRef as ReactComponent };